export const authenticatedAction = (state, payload) => {
  return {
    ...state,
    authenticated: payload
  };
};
